"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisclaimerContainer = exports.InsurancesAcceptedContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const constants_1 = require("../../lib/constants");
exports.InsurancesAcceptedContainer = styled_1.default.div `
  h2 {
    margin: 0;
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
    color: ${(0, ui_theme_1.fromTheme)('color_text')};

    @media screen and (max-width: ${constants_1.BREAKPOINTS.medium}px) {
      margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    }
  }
`;
exports.DisclaimerContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
//# sourceMappingURL=styles.js.map